import { StepTreePathChain } from '../utils/stepPathChainManagement'
import { useStepTreePath } from './useStepTreePath'

export const useIsNestedOccurrence = (testedLink: string) => {
  const stepTreePath = useStepTreePath()
  return new StepTreePathChain(stepTreePath).containsLink(testedLink)
}
